export const FETCH_TRANSLATIONS = 'TRANSLATIONS/FETCH_TRANSLATIONS';
export const FETCH_TRANSLATIONS_SUCCESS = 'TRANSLATIONS/FETCH_TRANSLATIONS_SUCCESS';
export const FETCH_TRANSLATIONS_ERROR = 'TRANSLATIONS/FETCH_TRANSLATIONS_ERROR';
export const MERGE_TRANSLATIONS = 'TRANSLATIONS/MERGE_TRANSLATIONS';

export interface FetchTranslations {
  type: typeof FETCH_TRANSLATIONS;
}

export interface FetchTranslationsSuccess {
  type: typeof FETCH_TRANSLATIONS_SUCCESS;
  payload: any;
}

export interface FetchTranslationsError {
  type: typeof FETCH_TRANSLATIONS_ERROR;
  payload: {
    error: string;
  };
}

export interface MergeTranslations {
  type: typeof MERGE_TRANSLATIONS;
  payload: Record<string, string | undefined>;
}

export type TranslationActionTypes = FetchTranslations | FetchTranslationsSuccess | FetchTranslationsError | MergeTranslations;
